import * as generalConstants from "../constants/event";

export const showLoading = () => ({
  type: generalConstants.SHOW_LOADING
});

export const hideLoading = () => ({
  type: generalConstants.HIDE_LOADING
});

export const fetchProjectCate = () => ({
  type: generalConstants.FETCH_PROJECT_CATE
});

export const fetchProjectCateSuccess = data => ({
  type: generalConstants.FETCH_PROJECT_CATE_SUCCESS,
  payload: { data }
});

export const fetchProjectCateFailed = error => ({
  type: generalConstants.FETCH_PROJECT_CATE_FAILED,
  payload: { error }
});

export const fetchNewsCate = () => ({
  type: generalConstants.FETCH_NEWS_CATE
});

export const fetchNewsCateSuccess = data => ({
  type: generalConstants.FETCH_NEWS_CATE_SUCCESS,
  payload: { data }
});

export const fetchNewsCateFailed = error => ({
  type: generalConstants.FETCH_NEWS_CATE_FAILED,
  payload: { error }
});

export const fetchSlider = () => ({
  type: generalConstants.FETCH_SLIDER
});

export const fetchSliderSuccess = data => ({
  type: generalConstants.FETCH_SLIDER_SUCCESS,
  payload: { data }
});

export const fetchSliderFailed = error => ({
  type: generalConstants.FETCH_SLIDER_FAILED,
  payload: { error }
});

export const fetchProjectById = params => ({
  type: generalConstants.FETCH_PROJECT_BY_ID,
  payload: { params }
});

export const fetchProjectByIdSuccess = data => ({
  type: generalConstants.FETCH_PROJECT_BY_ID_SUCCESS,
  payload: { data }
});

export const fetchProjectByIdFailed = error => ({
  type: generalConstants.FETCH_PROJECT_BY_ID_FAILED,
  payload: { error }
});

export const fetchAllProject = (params = {}) => ({
  type: generalConstants.FETCH_ALL_PROJECT,
  payload: { params }
});

export const fetchAllProjectSuccess = data => ({
  type: generalConstants.FETCH_ALL_PROJECT_SUCCESS,
  payload: { data }
});

export const fetchAllProjectFailed = error => ({
  type: generalConstants.FETCH_ALL_PROJECT_FAILED,
  payload: { error }
});

export const fetchNews = (params = {}) => ({
  type: generalConstants.FETCH_NEWS,
  payload: { params }
});

export const fetchNewsSuccess = data => ({
  type: generalConstants.FETCH_NEWS_SUCCESS,
  payload: { data }
});

export const fetchNewsFailed = error => ({
  type: generalConstants.FETCH_NEWS_FAILED,
  payload: { error }
});

export const fetchNewsById = (params = {}) => ({
  type: generalConstants.FETCH_NEWS_BY_ID,
  payload: { params }
});

export const fetchNewsByIdSuccess = data => ({
  type: generalConstants.FETCH_NEWS_BY_ID_SUCCESS,
  payload: { data }
});

export const fetchNewsByIdFailed = error => ({
  type: generalConstants.FETCH_NEWS_BY_ID_FAILED,
  payload: { error }
});

export const fetchNewsContent = alias => ({
  type: generalConstants.FETCH_NEWS_CONTENT,
  payload: { alias }
});

export const fetchNewsContentSuccess = data => ({
  type: generalConstants.FETCH_NEWS_CONTENT_SUCCESS,
  payload: { data }
});

export const fetchNewsContentFailed = error => ({
  type: generalConstants.FETCH_NEWS_CONTENT_FAILED,
  payload: { error }
});

// h code 

export const fetchAboutUs = () => ({
  type: generalConstants.FETCH_ABOUT_US_CONTENT,
});

export const fetchAboutUsSuccess = data => ({
  type: generalConstants.FETCH_ABOUT_US_CONTENT_SUCCESS,
  payload: { data }
}); 

export const fetchAboutUsFailed = error => ({
  type: generalConstants.FETCH_ABOUT_US_CONTENT_FAILED,
  payload: { error }
});

export const fetchSharedList = () => ({
  type: generalConstants.FETCH_SHARED_LIST,
});

export const fetchSharedListSuccess = data => ({
  type: generalConstants.FETCH_SHARED_LIST_SUCCESS,
  payload: { data }
}); 

export const fetchSharedListFailed = error => ({
  type: generalConstants.FETCH_SHARED_LIST_FAILED,
  payload: { error }
});

// -----------step 2------------
export const setDisplaySearchAction = () => ({
  type: generalConstants.SET_DISPLAY_SEARCH,
});

export const setKeySearchAction = keyString => ({
  type: generalConstants.SET_KEY_SEARCH,
  payload: keyString
});

export const fetchSharedDetailAction = alias => ({
  type: generalConstants.FETCH_DETAIL_SHARED,
  payload: { alias }
});

export const fetchSharedDetailSuccessAction = data => ({
  type: generalConstants.FETCH_DETAIL_SHARED_SUCCESS,
  payload: { data }
});
export const fetchSharedDetailFailedAction = error => ({
  type: generalConstants.FETCH_DETAIL_SHARED_FAILED,
  payload: { error }
});

export const fetchSearchAction = alias =>({
  type: generalConstants.FETCH_SEARCH,
  payload: { alias }
});
export const fetchSearchSuccessAction = data =>({
  type: generalConstants.FETCH_SEARCH_SUCCESS,
  payload: { data }
});
export const fetchSearchFailedAction = error =>({
  type: generalConstants.FETCH_SEARCH_FAILED,
  payload: { error }
});
// ---------General-------------------------
export const fetchGeneralContent = () => ({
  type: generalConstants.FETCH_GENERAL_CONTENT,
});

export const fetchGeneralContentSuccess = data => ({
  type: generalConstants.FETCH_GENERAL_CONTENT_SUCCESS,
  payload: { data }
});

export const fetchGeneralContentFail = error => ({
  type: generalConstants.FETCH_GENERAL_CONTENT_FAIL,
  payload: { error }
});

export const saveContact = (params) => ({
  type: generalConstants.SAVE_CONTACT,
  payload: {params}
});

export const saveContactSuccess = data => ({
  type: generalConstants.SAVE_CONTACT_SUCCESS,
  payload: { data }
});

export const saveContactFail = error => ({
  type: generalConstants.SAVE_CONTACT_FAILED,
  payload: { error }
});